// 
// Domain-specific types
// 

export interface DynamoBaseItem {
  pk: string;
  sk: string;
  type: string;  
  description?: string;
  last_modified?: string;
  last_modified_by?: string;
  version?: number;
  order?: number;
}

export interface Product extends DynamoBaseItem {  
  product: string;  
}

export interface Stage extends DynamoBaseItem {
  product: string;  
  stage: string;
}

export interface Context extends DynamoBaseItem {
  product: string;  
  stage: string;
  context: string;
}

export interface Attribute extends DynamoBaseItem {
  product: string;  
  stage: string;
  context: string;
  att_name: string;
  att_type: string;
  dq_rule_set?: string;
  client_id?: string;
  precision?: number;
}


export function isProduct(item: DynamoBaseItem): item is Product {
  return item.type === 'PRD' && 'product' in item;
}

export function isStage(item: any): item is Stage {
  return item.type === 'STG' && 'stage' in item && 'product' in item;
}

export function isContext(item: any): item is Context {
  return item.type === 'CTX' && 'context' in item && 'stage' in item && 'product' in item;
}

export function isAttribute(item: any): item is Attribute {
  return item.type === 'ATT' && 'context' in item && 'stage' in item && 'product' in item &&'att_name' in item;
}